<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Informe de uso y custodia de vehículos fiscales</h2>
      <h4>Antecedentes generales</h4>
      <div class="row">
        <div class="col-6">
          <list-groups
            :danger="errors.has('custom-document.division')"
            :danger-text="errors.first('custom-document.division')"
            v-validate="'required'"
            data-vv-as="división"
            autocomplete
            label="División *"
            name="division"
            data-cy="division"
            ref="division"
            v-model="formData.division"
            :typeList="stepTypes.GROUP"
            showOnlyDivissions
          />
        </div>
        <div class="col-6">
          <list-groups
            :danger="errors.has('custom-document.department')"
            :danger-text="errors.first('custom-document.department')"
            v-validate="'required'"
            data-vv-as="departamento/unidades"
            autocomplete
            label="Departamento/Unidades *"
            name="department"
            data-cy="department"
            ref="department"
            @input="setLeader"
            v-model="formData.department"
            :typeList="stepTypes.GROUP"
            showOnlyUnits
          />
        </div>
        <div class="col-6">
          <b-form-group label="Responsable departamento/unidad *">
            <b-form-input
              :state="errors.has('custom-document.leader') ? false : null"
              v-validate="'required'"
              data-vv-as="responsable dep/uni"
              data-cy="leader"
              name="leader"
              type="text"
              v-model="formData.leader"
              :placeholder="leaderPlaceholder"
              disabled
            />
            <div
              v-if="errors.has('custom-document.leader')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.leader') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Proceso revisado *">
            <b-form-input
              :state="errors.has('custom-document.process') ? false : null"
              v-validate="'required'"
              data-vv-as="proceso revisado"
              data-cy="process"
              name="process"
              type="text"
              v-model="formData.process"
            />
            <div
              v-if="errors.has('custom-document.process')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.process') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group>
            <list-user
              :danger="errors.has('custom-document.vehicle')"
              :danger-text="errors.first('custom-document.vehicle')"
              v-validate="'required'"
              data-vv-as="coordinación de vehículos fiscales"
              autocomplete
              data-cy="vehicle"
              name="vehicle"
              label="Coordinación de vehículos fiscales *"
              v-model="formData.vehicle"
              ref="vehicle"
              @full-user="setPosition"
            />
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Cargo *">
            <b-form-input
              :state="errors.has('custom-document.position') ? false : null"
              v-validate="'required'"
              data-vv-as="cargo"
              data-cy="position"
              name="position"
              type="text"
              v-model="formData.position"
            />
            <div
              v-if="errors.has('custom-document.position')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.position') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group>
            <list-user
              :danger="errors.has('custom-document.madeBy')"
              :danger-text="errors.first('custom-document.madeBy')"
              v-validate="'required'"
              data-vv-as="informe realizado por"
              autocomplete
              data-cy="made-by"
              name="madeBy"
              label="Informe realizado por *"
              v-model="formData.madeBy"
              ref="madeBy"
              @full-user="setPositionMadeBy"
            />
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Cargo *">
            <b-form-input
              :state="errors.has('custom-document.madeByPosition') ? false : null"
              v-validate="'required'"
              data-vv-as="cargo"
              data-cy="made-by-position"
              name="madeByPosition"
              type="text"
              v-model="formData.madeByPosition"
            />
            <div
              v-if="errors.has('custom-document.madeByPosition')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.madeByPosition') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="col-md-12">
        <vs-divider/>
      </div>
      <h4>Identificación de la revisión</h4>
      <div class="row">
        <div class="col-12">
          <div class="col-12 text-center">
            <strong>Alcance</strong>
          </div>
          <div class="row">
            <div class="col-6 text-center">
              <b-form-group label="Mes *">
                <v-select
                  :class="{'v-select-danger': errors.has('custom-document.scopeMonth')}"
                  :state="errors.has('custom-document.scopeMonth') ? false : null"
                  v-validate="'required'"
                  data-vv-as="mes"
                  name="scopeMonth"
                  data-cy="scope-month"
                  :options="months"
                  v-model="formData.scopeMonth"
                />
                <div
                  v-if="errors.has('custom-document.scopeMonth')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                  style="height: 19px;">
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.scopeMonth') }}
                  </span>
                </div>
              </b-form-group>
            </div>
            <div class="col-6 text-center">
              <b-form-group label="Año *">
                <v-select
                  taggable
                  :class="{'v-select-danger': errors.has('custom-document.scopeYear')}"
                  :state="errors.has('custom-document.scopeYear') ? false : null"
                  v-validate="'required'"
                  data-vv-as="año"
                  name="scopeYear"
                  data-cy="scope-year"
                  :options="years"
                  v-model="formData.scopeYear"
                />
                <div
                  v-if="errors.has('custom-document.scopeYear')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                  style="height: 19px;">
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.scopeYear') }}
                  </span>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <vs-divider/>
      </div>
      <h4>Informe detallado de resultados</h4>
      <div class="col-md-12">
        <b-form-group label="Objetivos específicos *">
          <editor-text
            :danger="errors.has('custom-document.specificObjectives')"
            :danger-text="errors.first('custom-document.specificObjectives')"
            v-validate="'required'"
            data-cy="specific-objectives"
            data-vv-as="objetivos específicos"
            :max-length="14000"
            name="specificObjectives"
            ref="specificObjectives"
            v-model="formData.specificObjectives"
            with-counter
          />
        </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-group label="Resultado detallado de la revisión *">
          <editor-text
            :class="{'v-select-danger': errors.has('custom-document.reviewResult')}"
            :danger="errors.has('custom-document.reviewResult')"
            :danger-text="errors.first('custom-document.reviewResult')"
            v-validate="'required'"
            data-cy="review-result"
            data-vv-as="resultado detallado revisión"
            :max-length="14000"
            name="reviewResult"
            ref="reviewResult"
            v-model="formData.reviewResult"
            with-counter
          />
        </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-group label="Nota *">
          <editor-text
            :class="{'v-select-danger': errors.has('custom-document.note')}"
            :danger="errors.has('custom-document.note')"
            :danger-text="errors.first('custom-document.note')"
            v-validate="'required'"
            data-cy="note"
            data-vv-as="nota"
            :max-length="14000"
            name="note"
            ref="note"
            v-model="formData.note"
            with-counter
          />
        </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-group label="Hallazgos *">
          <editor-text
            :class="{'v-select-danger': errors.has('custom-document.findings')}"
            :danger="errors.has('custom-document.findings')"
            :danger-text="errors.first('custom-document.findings')"
            v-validate="'required'"
            data-cy="findings"
            data-vv-as="hallazgos"
            :max-length="14000"
            name="findings"
            ref="findings"
            v-model="formData.findings"
            with-counter
          />
        </b-form-group>
      </div>
      <div class="row align-items-center mt-5">
        <div class="col-md-12">
          <label>Adjuntos *</label>
        </div>
        <div class="col-md-3 align-items-end">
          <upload-file
            :color="attachmentError ? 'danger' : 'primary'"
            permission="*"
            accept="application/pdf, .doc, .docx, .xlsv, .ppt"
            text="Seleccionar documentos"
            v-model="file"
            data-cy="uploadFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
            @input="addFile()"
          />
        </div>
        <div class="col-2" v-for="file in formData.attachments" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="25px" color="primary"/>
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              data-cy="removeOthersFile"
              @click="removeOthersFile(file.id)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!!error.message"
        class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-right"
      >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
      </div>
    </form>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
  </div>
</template>

<script>

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapActions, mapGetters } from 'vuex';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import { getUsersByGroup } from '@/febos/servicios/api/empresas.api';
import { queueTask, verifyQueueTask } from '@/febos/servicios/api/herramientas.api';
import ListUser from '@/febos/chile/lists/components/ListUser';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  name: 'INF',
  components: {
    UploadFile,
    EditorText,
    ListUser,
    ListGroups
  },
  data() {
    return {
      formData: {
        attachments: [],
        division: '',
        department: '',
        leader: '',
        process: '',
        vehicle: '',
        position: '',
        madeBy: '',
        madeByPosition: '',
        scopeMonth: '',
        scopeYear: '',
        scope: '',
        specificObjectives: '',
        reviewResult: '',
        note: '',
        findings: ''
      },
      attachmentError: false,
      maxLengthDescription: 10000,
      saving: false,
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      years: Array(15).fill(0).map((val, idx) => new Date().getFullYear() - idx),
      file: {},
      error: {
        message: ''
      },
      stepTypes: StepTypes,
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'userToken'
    ]),
    leaderPlaceholder() {
      return this.formData.department ? 'Buscando responsable...' : 'Selecciona un departamento/unidad...';
    }
  },
  methods: {
    ...mapActions([
      'setApiError'
    ]),
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    setPosition(user) {
      this.formData.position = user.position || 'Sin cargo';
    },
    setPositionMadeBy(user) {
      this.formData.madeByPosition = user.position || 'Sin cargo';
    },
    async setLeader(event) {
      this.formData.leader = '';

      const { data } = await getUsersByGroup({
        empresaId: this.company.id,
        pagina: 1,
        filas: 9999,
        groupId: event
      });

      if (data && data.usuarios) {
        const lider = data.usuarios.find((user) => user.esLider === 'Y');
        this.formData.leader = lider ? lider.nombre : 'Sin responsable';
      }
    },
    async addFile() {
      this.attachmentError = false;
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.attachments.push(this.file);
      this.error.message = '';

      this.validateAttachments();
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('INF', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    validateAttachments() {
      const hasAttachments = this.formData.attachments.length;
      if (!hasAttachments) {
        this.error.message = 'Debes seleccionar al menos un documento';
        this.attachmentError = true;
      }
      return hasAttachments;
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async verifyTask(taskId, callBack) {
      const response = await verifyQueueTask(taskId);
      try {
        switch (response.data.estado) {
          case 0: // Esta creada y aun no iniciado
          case 1: // Esta creada y aun no iniciado
          case 2:
            setTimeout(() => {
              this.verifyTask(taskId, callBack);
            }, 3000);
            break;
          case 3:
            if (response.data.avance > 100) {
              await this.verifyTask(taskId, callBack);
            } else if (response.data.resultado) {
              const fetchedJson = await fetch(response.data.resultado);
              const jsonResponse = await fetchedJson.json();
              window.open(jsonResponse.pdf, '_blank');
              this.$bvToast.toast(
                'Archivo generado',
                {
                  title: 'Listo!',
                  variant: 'primary',
                  pauseOnHover: true,
                  solid: true,
                  autoHideDelay: 2000
                }
              );
              this.back();
              this.saving = false;
            }
            break;
          case 4:
            await this.setApiError({
              codigo: 10,
              duracion: response.data.duracion,
              fecha: response.data.fecha,
              mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
              seguimientoId: response.data.seguimientoId
            });
            this.saving = false;
            if (response.data.avance > 100) {
              await this.setApiError({
                codigo: 10,
                duracion: response.data.duracion,
                fecha: response.data.fecha,
                mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
                seguimientoId: response.data.seguimientoId
              });
              this.saving = false;
            }
            break;
          default:
            console.log('default');
            break;
        }
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    async save() {
      this.attachmentError = false;
      const isValid = await this.validateForm('custom-document');
      const hasAttachments = this.validateAttachments();
      if (!isValid || !hasAttachments) {
        return;
      }

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: this.$route.query,
          formData: {
            ...this.formData,
            division: this.$refs.division.getOption(),
            department: this.$refs.department.getOption(),
            vehicle: this.$refs.vehicle.getOption(),
            madeBy: this.$refs.madeBy.getOption(),
          }
        };
        const response = await ioCreateCustomDocument(payload);
        // await this.generatePdf(response.data.document.id);
        const task = await queueTask({
          proceso: 'py_febos_core_procesos',
          ejecutarDeInmediato: 'si'
        }, btoa(unescape(encodeURIComponent(JSON.stringify({
          handler: 'funcion_lambda.febos.funciones.documents.type._id.get.handler',
          type: 'INF',
          id: response.data.document.id,
          aplicacion: 'ED',
          dominioPortal: 'portal.escritoriodigital.cl',
          pdf: 'si',
          empresa: this.company.iut,
          token: this.userToken,
          body: {},
          stage: `${process.env.VUE_APP_AMBIENTE}`,
          pais: 'cl'
        })))));
        setTimeout(() => {
          this.verifyTask(task.data.tareaId);
        }, 1000);
      } finally {
        console.log('fin');
      }
    }
  }
};
</script>
